import { BillingContactType } from './billing-contact-type';

export class BillingContactModel {
    Id = 0;
    ObjectId = 0;
    ObjectType = 1;
    Name = '';
    CountryCode = '';
    CountryId: any = 0;
    Phone = '';
    Email = '';
    IsDefault = false;
    BillingContactType = BillingContactType.Contact;

    Initialize(data) {
        Object.assign(this, data);
        return this;
    }
}
